export function SearchIcon({isMobile = false}) {
  if (isMobile) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
        <g clipPath="url(#clip0_4705_36038)">
        <path d="M4.28683 7.143C5.04459 7.143 5.77132 6.84198 6.30714 6.30616C6.84295 5.77034 7.14397 5.04362 7.14397 4.28585C7.14397 3.52809 6.84295 2.80137 6.30714 2.26555C5.77132 1.72973 5.04459 1.42871 4.28683 1.42871C3.52907 1.42871 2.80234 1.72973 2.26653 2.26555C1.73071 2.80137 1.42969 3.52809 1.42969 4.28585C1.42969 5.04362 1.73071 5.77034 2.26653 6.30616C2.80234 6.84198 3.52907 7.143 4.28683 7.143Z" stroke="#B8B8B8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.75112 8.75014L6.42969 6.42871" stroke="#B8B8B8" strokeLinecap="square" strokeLinejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_4705_36038">
        <rect width="10" height="10" fill="white"/>
        </clipPath>
        </defs>
      </svg>
    )
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M6.85659 11.4285C8.069 11.4285 9.23176 10.9469 10.0891 10.0896C10.9464 9.23225 11.428 8.06949 11.428 6.85707C11.428 5.64465 10.9464 4.48189 10.0891 3.62459C9.23176 2.76728 8.069 2.28564 6.85659 2.28564C5.64417 2.28564 4.48141 2.76728 3.6241 3.62459C2.76679 4.48189 2.28516 5.64465 2.28516 6.85707C2.28516 8.06949 2.76679 9.23225 3.6241 10.0896C4.48141 10.9469 5.64417 11.4285 6.85659 11.4285Z" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.9994 13.9999L10.2852 10.2856" stroke="black" strokeLinecap="square" strokeLinejoin="round"/>
    </svg>
  )
}

export const CloseIcon: React.FC<{ onClick: () => void, isMobile?: boolean }> = ({ onClick, isMobile=false }) => (
  <svg className="cursor-pointer" onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={isMobile ? "10" : "12"} height={isMobile ? "10" : "12"} viewBox="0 0 12 12" fill="none">
    <path d="M10.9999 0.5L1.1416 10.3583L10.9999 0.5Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round"/>
    <path d="M10.8583 10.3583L1 0.5L10.8583 10.3583Z" stroke="black" strokeMiterlimit="10" strokeLinecap="round"/>
  </svg>
)
